import { HourglassMediumIcon } from "@phosphor-icons/react";
import { goToUrl } from "apps/visits/core/utils/go-to-url";
import { useTranslation } from "react-i18next";
import { Button } from "@/core/shared/v2/ui/button";
import { IntersectionFadeIn } from "@/core/shared/v2/ui/intersection-fade-in";
import { Card, HeroLayout } from "../components";

export const FinishedAction = () => {
  const { t } = useTranslation();

  const handleButton = () => {
    goToUrl("/");
  };

  const description = t("cmsTranslations.finished_action.description");

  return (
    <HeroLayout>
      <IntersectionFadeIn className="relative z-20 h-full">
        <div className="mx-auto flex h-full max-w-[800px] items-center justify-center px-4">
          <Card className="flex flex-col items-center text-center">
            <HourglassMediumIcon className="size-8 text-black" />
            <h1 className="mt-1 mb-4 font-semibold text-2xl">{t("cmsTranslations.finished_action.title")}</h1>
            {description && <p>{description}</p>}
            <p className="mt-8 mb-6 max-w-96">{t("GROUP_ACTIONS_ORDERING.FINISHED_ACTION.CHECK_OFFER")}</p>
            <Button variant="primary" size="lg" className="w-full md:w-1/3" onClick={handleButton}>
              {t("GROUP_ACTIONS_ORDERING.FINISHED_ACTION.BUTTON_LABEL")}
            </Button>
          </Card>
        </div>
      </IntersectionFadeIn>
    </HeroLayout>
  );
};
